// extracted by mini-css-extract-plugin
export default {"container":"bcoin_container__PjISy","tabContainer":"bcoin_tabContainer__V4jfL"};